const VALUE_MAPS = {
	caseType: {
		860580000: "Product Information",
		860580001: "Parts Related",
		860580002: "Tech Service Visit Request",
		860580003: "Tech Support",
		860580004: "General Inquiry",
		860580005: "AMF Method",
		860580006: "Repair and Modernization",
	},
	caseStatus: {
		1: "In Progress",
		2: "On Hold",
		3: "Waiting for Details",
		4: "Resolved",
		5: "Closed",
		6: "Cancelled",
		2000: "Cancelled",
		860580000: "Ready to Close",
		860580002: "Waiting for Call Back",
		860580003: "New",
	},
	casePriority: {
		1: "Standard",
		2: "High",
	},
	caseOrigin: {
		1: "Phone",
		2: "Email",
		3: "Web",
		4: "In-Person Visit",
		860580000: "Mobile",
	},
	region: {
		100000000: "EMEAAP",
		100000001: "GEOGRAPHIC.CANADA",
		100000002: "CHINA",
		100000003: "USL",
	},
	safetyIssue: {
		860580000: "Yes",
		860580001: "No",
	},
};

// The DB returns these codes as numeric strings with a trailing ".0" for some fields
// (e.g. case_type comes back as "860580003.0", confirmed via a live query) — a direct
// key lookup against VALUE_MAPS' integer-like keys silently misses and falls through to
// the raw unlabeled code. Normalize via Number()+Math.trunc() first, same fix already
// applied server-side in iEcom_server/src/aether/tools/case_helpers.js's normalizeCaseCode.
const mapValue = (key, type) => {
	if (!type || !(type in VALUE_MAPS)) return key;
	const num = Number(key);
	const normalizedKey = Number.isFinite(num) ? String(Math.trunc(num)) : key;
	const value = VALUE_MAPS[type][normalizedKey];
	return value ?? key ?? "";
};

export const mapCasesResponse = (cases = []) =>
	cases.map((c) => ({
		...c,
		case_type: mapValue(c.case_type, "caseType"),
		case_status: mapValue(c.case_status, "caseStatus"),
		case_priority: mapValue(c.case_priority, "casePriority"),
		case_origin: mapValue(c.case_origin, "caseOrigin"),
		safety_issue: mapValue(c.safety_issue, "safetyIssue"),
		region: mapValue(c.region, "region"),
	}));
